import React from 'react'

import AvatarGroup from '../../AvatarGroup'
import MediaAvatar from '../../../atoms/MediaAvatar'

import { useUserAPI } from '../../../../providers/UserAPIProvider'
import useStyles from './styles'

const AvatarArea = ({ userIDs, intersect, isDirect }) => {
  const { allUsers } = useUserAPI()

  const users = React.useMemo(
    () => Object.values(allUsers).filter(({ id }) => userIDs.includes(id)),
    [allUsers, userIDs]
  )

  const classes = useStyles({ isDirect })

  return (
    <div onClick={e => e.stopPropagation()} className={classes.holder}>
      <AvatarGroup>
        {users.length > 0
          ? users.map(user => (
              <MediaAvatar key={user.id} user={user} showBadge group />
            ))
          : userIDs.map(id => <MediaAvatar key={id} intersect={intersect} />)}
      </AvatarGroup>
    </div>
  )
}

export default AvatarArea
